export enum PATHS {
  USER_PATH = '/user',
  LOGIN_PATH = '/login',
}
